import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { IApiRobotConfiguration } from 'src/app/models_new/classes/api-models/ApiRobotConfiguration';

@Component({
  selector: 'app-card-robot-config-list',
  templateUrl: './card-robot-config-list.component.html',
  styleUrls: ['./card-robot-config-list.component.scss'],
})
export class CardRobotConfigListComponent implements OnChanges {
  @Input() robotConfigurations: IApiRobotConfiguration[];
  @Input() sortOptions: { label: string; value: string; selected: boolean }[];
  @Input() selectedConfigsOnInit: IApiRobotConfiguration[];
  @Output() textFilter: EventEmitter<string> = new EventEmitter();
  @Output() sortSelected: EventEmitter<{
    label: string;
    value: string;
    selected: boolean;
  }> = new EventEmitter();
  @Output() selectedConfig: EventEmitter<IApiRobotConfiguration[]> =
    new EventEmitter();

  currentPage: number = 0;
  cardsPerPage: number = 5;
  pages: number[];

  displayedConfigs: IApiRobotConfiguration[][];
  selected_configurations: IApiRobotConfiguration[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (this.robotConfigurations) {
      this.pages = Array.from(
        Array(
          Math.ceil(this.robotConfigurations.length / this.cardsPerPage)
        ).keys()
      );
    }

    this.displayedConfigs = [];

    let config_it = 0;
    if (this.pages) {
      for (let _ of this.pages) {
        this.displayedConfigs.push(
          this.robotConfigurations.slice(
            config_it,
            config_it + this.cardsPerPage
          )
        );
        config_it += this.cardsPerPage;
      }
    }
    if (
      changes.selectedConfigsOnInit.currentValue &&
      changes.selectedConfigsOnInit.firstChange
    ) {
      changes.selectedConfigsOnInit.currentValue.forEach((config) => {
        this.selectCard(config);
      });
    }
  }

  pageChange(increment: number) {
    this.currentPage += increment;
  }

  incrementPageDisabled(element_page: number) {
    return element_page === this.currentPage;
  }

  sorterSelected(e: { label: string; value: string; selected: boolean }) {
    this.sortOptions.find((f) => f.selected).selected = false;
    this.sortOptions.find((f) => f.value === e.value).selected = true;
    this.sortSelected.emit(e);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.textFilter.emit(filterValue);
  }

  selectCard(selected_config: IApiRobotConfiguration) {
    let existing_config = this.selected_configurations.findIndex(
      (config) => config.id === selected_config.id
    );
    if (existing_config != -1) {
      this.selected_configurations.splice(existing_config, 1);
    } else {
      this.selected_configurations.push(selected_config);
    }

    this.selectedConfig.emit(this.selected_configurations);
  }

  cardSelected(config: IApiRobotConfiguration) {
    return this.selected_configurations.find(
      (selected_config) => selected_config.id === config.id
    )
      ? true
      : false;
  }
}
